/* assets/skin-personality-quiz.js */
(function () {
  "use strict";

  var QUESTIONS = [
    {
      text: "How does your skin feel by midday?",
      answers: [
        { text: "Oily or shiny", type: "oily_combo" },
        { text: "Tight or dry", type: "dry_normal" },
        { text: "Bumpy or red", type: "acne_prone" },
        { text: "Dull or flat", type: "anti_aging" }
      ]
    },
    {
      text: "What happens without a routine?",
      answers: [
        { text: "Oil builds up", type: "oily_combo" },
        { text: "Gets flaky", type: "dry_normal" },
        { text: "Breakouts appear", type: "acne_prone" },
        { text: "Looks tired", type: "anti_aging" }
      ]
    },
    {
      text: "How does your skin react to new products?",
      answers: [
        { text: "More oil", type: "oily_combo" },
        { text: "Feels tight", type: "dry_normal" },
        { text: "Gets irritated", type: "acne_prone" },
        { text: "No change", type: "anti_aging" }
      ]
    },
    {
      text: "Biggest concern right now?",
      answers: [
        { text: "Shine or pores", type: "oily_combo" },
        { text: "Dryness or flaking", type: "dry_normal" },
        { text: "Bumps or marks", type: "acne_prone" },
        { text: "Lines or sagging", type: "anti_aging" }
      ]
    },
    {
      text: "One word for your skin today?",
      answers: [
        { text: "Shiny", type: "oily_combo" },
        { text: "Thirsty", type: "dry_normal" },
        { text: "Reactive", type: "acne_prone" },
        { text: "Tired", type: "anti_aging" }
      ]
    }
  ];

  var TYPES = {
    oily_combo: {
      title: "Oily & Combination",
      oneliner: "Your skin overproduces oil, especially in the T-zone.",
      tips: ["Gentle cleansing", "Lightweight moisture", "Daily SPF"]
    },
    dry_normal: {
      title: "Dry & Normal",
      oneliner: "Your skin needs consistent hydration and gentle care.",
      tips: ["Skip harsh cleansers", "Layer hydration", "Protect your barrier"]
    },
    acne_prone: {
      title: "Acne Prone",
      oneliner: "Your skin is reactive and needs a calm, steady routine.",
      tips: ["Stay consistent", "Don't skip moisture", "Wear SPF daily"]
    },
    anti_aging: {
      title: "Anti-Aging",
      oneliner: "Your skin needs protection and overnight recovery.",
      tips: ["SPF every day", "Recovery at night", "Keep it gentle"]
    }
  };

  // Tie-break priority: acne is most actionable, then oily, dry, aging
  var TIE_PRIORITY = ["acne_prone", "oily_combo", "dry_normal", "anti_aging"];

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i];
      a[i] = a[j];
      a[j] = tmp;
    }
    return a;
  }

  function initSection(el) {
    var id = el.getAttribute("data-section-id");
    var boot = (window.__SPQ__ && window.__SPQ__[id]) || {};

    var welcomeScreen = el.querySelector("#spqWelcome-" + id);
    var quizScreen = el.querySelector("#spqQuiz-" + id);
    var loadingScreen = el.querySelector("#spqLoading-" + id);
    var resultScreen = el.querySelector("#spqResult-" + id);
    var progressBar = el.querySelector("#spqProgress-" + id);
    var counter = el.querySelector("#spqCounter-" + id);
    var qText = el.querySelector("#spqQText-" + id);
    var answersEl = el.querySelector("#spqAnswers-" + id);
    var backBtn = el.querySelector("#spqBack-" + id);
    var resultTitle = el.querySelector("#spqResultTitle-" + id);
    var resultDesc = el.querySelector("#spqResultDesc-" + id);
    var tipsEl = el.querySelector("#spqTips-" + id);
    var shopBtn = el.querySelector("#spqShopBtn-" + id);
    var startBtn = el.querySelector("#spqStart-" + id);
    var restartBtn = el.querySelector("#spqRestart-" + id);

    var allScreens = [welcomeScreen, quizScreen, loadingScreen, resultScreen];
    var currentQ = 0;
    var scores = { oily_combo: 0, dry_normal: 0, acne_prone: 0, anti_aging: 0 };
    var history = []; // tracks which type was picked per question

    function showScreen(screen) {
      allScreens.forEach(function (s) { if (s) s.hidden = true; });
      if (screen) screen.hidden = false;
    }

    function updateBackBtn() {
      if (backBtn) backBtn.style.display = currentQ > 0 ? "" : "none";
    }

    function renderQuestion() {
      var q = QUESTIONS[currentQ];
      if (counter) counter.textContent = "Question " + (currentQ + 1) + " of " + QUESTIONS.length;
      if (qText) qText.textContent = q.text;
      if (progressBar) progressBar.style.width = ((currentQ / QUESTIONS.length) * 100) + "%";
      updateBackBtn();
      if (!answersEl) return;

      // Re-trigger enter animation
      answersEl.classList.remove("spq__fadeIn");
      if (qText) qText.classList.remove("spq__fadeIn");
      void answersEl.offsetWidth; // force reflow
      answersEl.classList.add("spq__fadeIn");
      if (qText) qText.classList.add("spq__fadeIn");

      answersEl.innerHTML = "";
      var shuffled = shuffle(q.answers);
      shuffled.forEach(function (a) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "spq__answer";
        btn.textContent = a.text;
        btn.addEventListener("click", function () {
          selectAnswer(a.type, btn);
        });
        answersEl.appendChild(btn);
      });
    }

    function selectAnswer(type, btn) {
      // Highlight selected + disable all
      var buttons = answersEl.querySelectorAll(".spq__answer");
      for (var i = 0; i < buttons.length; i++) buttons[i].disabled = true;
      btn.classList.add("is-selected");

      scores[type]++;
      history.push(type);

      setTimeout(function () {
        currentQ++;
        if (currentQ >= QUESTIONS.length) {
          showLoading();
        } else {
          renderQuestion();
        }
      }, 350);
    }

    function goBack() {
      if (currentQ <= 0 || history.length === 0) return;
      var lastType = history.pop();
      scores[lastType]--;
      currentQ--;
      renderQuestion();
    }

    function showLoading() {
      if (progressBar) progressBar.style.width = "100%";
      showScreen(loadingScreen);
      setTimeout(showResult, 1500);
    }

    function showResult() {
      var maxScore = 0;
      var winner = TIE_PRIORITY[TIE_PRIORITY.length - 1];

      // Find highest score, use TIE_PRIORITY for ties
      for (var i = 0; i < TIE_PRIORITY.length; i++) {
        var key = TIE_PRIORITY[i];
        if (scores[key] > maxScore) {
          maxScore = scores[key];
          winner = key;
        }
      }

      var type = TYPES[winner];
      if (resultTitle) resultTitle.textContent = type.title;
      if (resultDesc) resultDesc.textContent = type.oneliner;

      if (tipsEl) {
        tipsEl.innerHTML = "";
        type.tips.forEach(function (tip) {
          var li = document.createElement("li");
          li.className = "spq__tip";
          li.textContent = tip;
          tipsEl.appendChild(li);
        });
      }

      var collectionUrl = boot.collections && boot.collections[winner];
      if (shopBtn && collectionUrl) {
        shopBtn.href = collectionUrl;
        shopBtn.textContent = "Browse " + type.title + " products \u2192";
        shopBtn.style.display = "";
      } else if (shopBtn) {
        shopBtn.style.display = "none";
      }

      showScreen(resultScreen);
    }

    function reset() {
      currentQ = 0;
      history = [];
      var keys = Object.keys(scores);
      for (var i = 0; i < keys.length; i++) scores[keys[i]] = 0;
      if (progressBar) progressBar.style.width = "0%";
      showScreen(welcomeScreen);
    }

    if (startBtn) {
      startBtn.addEventListener("click", function () {
        showScreen(quizScreen);
        renderQuestion();
      });
    }

    if (backBtn) {
      backBtn.addEventListener("click", goBack);
      backBtn.style.display = "none";
    }

    if (restartBtn) {
      restartBtn.addEventListener("click", reset);
    }
  }

  function initAll() {
    var sections = document.querySelectorAll(".spq[data-section-id]");
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
